export default __webpack_public_path__ + "static/media/agriculture_left.a1ac541a.png";